import s from "./CuponesGanadores.module.css";
import React, { useEffect, useState } from "react";

//assets
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

//MaterialUi
import {
  Grid,
  Box,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  TableContainer,
  Table,
  TableHead,
  MenuItem,
  Button,
  Select,
  TableCell,
  TableBody,
  TableRow,
  Avatar,
  Pagination,
  CircularProgress,
} from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import prizesService from "../../../api/delivery/prizesService";
import Pager from "../../Shared/Pagination/Pagination";
import useTranslationException from "../../../helpers/exceptions";
export const CuponesGanadores = () => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const { textColor } = useSelector((state) => state.local);

  const [agencySelected, setAgencySelected] = useState(null);
  const [prizes, setPrizes] = useState({});
  const [gameSelected, setGameSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    gameId: 0,
    agency: null,
    owner: "",
    coupon: null,
    raffle: 0,
    serie: "",
    amount: 0,
  });

  const [filters, setFilters] = useState({
    gameId: "",
    serie: "",
    raffleNumber: "",
    gameType: "",
  });

  //Pagianción
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  const handleChangeGame = (e) => {
    let id = e.target.value;
    let game = allGameOffersActive.find((item) => item.modality.game.id === id);

    setGameSelected(game);
    setForm((prev) => ({ ...prev, gameId: id, serie: "", raffle: "" }));
    setFilters({
      ...filters,
      gameId: id,
      gameType: game.modality.mode.id,
      serie: "",
      raffleNumber: "",
    });
  };

  const getPrizesFiltered = () => {
    setLoading(true);
    prizesService
      .getPrizes(page, pageSize, filters)
      .then((res) => {
        setTotalPages(res.totalPages);
        setPrizes(res.content[0]);
        setLoading(false);
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return (
    <Grid container item xs={12} className={s.container}>
      <Grid item xs={11} className={s.titleContainer}>
        <EmojiEventsIcon sx={{ color: "primary.main", fontSize: "1.8rem" }} />
        <h4>{t("winningCoupons")}</h4>
      </Grid>

      <Grid item container xs={10} className={s.form}>
        <Grid item xs={12} lg={5}>
          <p>{t("game")}</p>
          <Select
            value={form.gameId}
            onChange={(e) => handleChangeGame(e)}
            sx={{ width: "90%" }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            {allGameOffersActive.map((item, i) => (
              <MenuItem key={i} value={item.modality.game.id}>
                {item.modality.game.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} lg={5}>
          <p>{t("gameKind")}</p>
          <TextField
            value={gameSelected?.modality?.mode?.name}
            disabled={true}
            sx={{ width: "90%" }}
          />
        </Grid>
        {gameSelected?.modality?.mode?.id === 1 ? (
          <>
            <Grid item xs={12} lg={5}>
              <p>{t("drawNumber")}</p>
              <TextField
                value={form.raffle}
                disabled={gameSelected?.modality?.mode?.id !== 1}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, raffle: e.target.value }));
                  setFilters({ ...filters, raffleNumber: e.target.value });
                }}
                sx={{ width: "90%" }}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} lg={5}>
              <p>{t("serie")}</p>
              <TextField
                value={form.serie}
                disabled={gameSelected?.modality?.mode?.id === 1}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, serie: e.target.value }));
                  setFilters({ ...filters, serie: e.target.value });
                }}
                sx={{ width: "90%" }}
              />
            </Grid>
          </>
        )}
        {/* <Grid item xs={12} lg={5}>
                    <p>{t('price')}</p>
                    <TextField
                        value={form.amount}
                        onChange={e => setForm(prev => ({...prev, amount: e.target.value}))}
                        sx={{width: '90%'}}
                    />
                </Grid> */}
        <Grid item xs={10} lg={5} sx={{ alignSelf: "flex-end" }}>
          <Button
            variant="contained"
            onClick={getPrizesFiltered}
            /*disabled={!(form.gameId && form.coupon && (form.raffle || form.serie) && form.agency)}*/ className={
              s.send
            }
          >
            {t("consult")}
          </Button>
        </Grid>
        {prizes?.leght ? (
          <>
            <Grid item xs={11} className={s.dataContainer}>
              {loading ? (
                <CircularProgress size={"4rem"} />
              ) : (
                <TableContainer className={s.tableContainer}>
                  <Table className={s.table}>
                    <TableHead
                      sx={{ backgroundColor: "primary.main" }}
                      className={s.tableHead}
                    >
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("logo")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("name")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("modality")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("lottery")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("state")}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("date")}
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {console.log("-> ", prizes)}
                      {prizes?.map((g, i) => (
                        <React.Fragment key={i}>
                          <TableRow
                            sx={{
                              "&:hover": { backgroundColor: "secondary.light" },
                            }}
                          >
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              <Avatar
                                src={g.modality?.game?.image}
                                sx={{ width: 56, height: 56 }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {g.modality?.game?.name}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {g.modality?.mode?.name}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {g.modality?.game?.lottery?.name}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {g.enabled ? t("active") : t("inactive")}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {g.dateCreate || "-"}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: "50px",
              }}
            >
              <Pager
                pageSize={pageSize}
                setPageSize={setPageSize}
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                pageCustom={pageCustom}
                setPageCustom={setPageCustom}
              />
            </Grid>
          </>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
};
